import { useContext } from 'react';
import { GlobalState } from "./../../context/globalState";
import Images from "./../../asset/exportImages";
import { Row, Col, Breadcrumb } from "antd"

const Header = () => {
  const { isMobile, setStep, step } = useContext(GlobalState);
  const arrStep = [
    { title: 'Bảo hiểm An Gia 247', step: 1 },
    { title: 'Chọn chương trình bảo hiểm', step: 2 },
    { title: 'Thông tin người mua bảo hiểm', step: 3 },
    { title: 'Thông tin thanh toán', step: 4 }
  ]
  return (
    <Row>
      <div style={{ height: isMobile ? 50 : 60 }}></div>
      <Col xs={24} style={{ background: '#fff', boxShadow: "0px 2px 4px 0px #0000001A", position: 'fixed', top: 0, width: '100%', zIndex: 1000 }}>
        <div style={{ padding: isMobile ? '0px 15px' : '0px 45px' }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', height: isMobile ? 50 : 60, margin: '0px auto' }}>
            {
              isMobile &&
              <div style={{ fontWeight: 500 }}>
                {arrStep.filter((item) => item.step == step)[0].title}
              </div>
            }
            {
              !isMobile &&
              <div style={{ display: 'flex', alignItems: 'center' }}>
                {
                  step > 1 &&
                  <div onClick={() => setStep(step > 1 ? (step - 1) : 1)} style={{ cursor: 'pointer' }}>
                    <img src={Images.ICBackHeader} width={'32px'} />
                  </div>
                }
                <div style={{ fontWeight: 500, marginLeft: 15}}>
                  <Breadcrumb style={{ color: '#343A40' }}
                    items={arrStep
                      .filter((item) => item.step <= step)
                      .map((item) => ({
                        title: (
                          <div
                            style={{ cursor: "pointer", whiteSpace: 'nowrap' }}
                            onClick={() => setStep(item.step)}
                          >
                            {item.title}
                          </div>
                        ),
                      }))}
                    separator={<img style={{ marginBottom: -5 }} src={Images.ICBreadCum} />}
                  />
                </div>
              </div>
            }
            <img onClick={() => setStep(1)} src={isMobile ? Images.ICLogoGCDK : Images.ICLogoGCDK} width={isMobile ? "51px" : "82px"} height={isMobile ? "30px" : "48px"} />
          </div>
        </div>
      </Col>
    </Row>
  );
}

export default Header;